import { createContext, Dispatch, SetStateAction } from 'react';

export interface INavFolder {
  id: string | null;
  name: string;
}

export const ROOT_FOLDER: INavFolder = { name: 'root', id: null };

export const NavFoldersContext = createContext<INavFolder[]>([ROOT_FOLDER]);
NavFoldersContext.displayName = 'NavFoldersContext';

export const UpdateNavFoldersContext = createContext<Dispatch<SetStateAction<INavFolder[]>> | null>(null);
UpdateNavFoldersContext.displayName = 'UpdateNavFoldersContext';

export const CurrentFolderContext = createContext<INavFolder>(ROOT_FOLDER);
CurrentFolderContext.displayName = 'CurrentFolderContext';

export const UpdateCurrentFolderContext = createContext<Dispatch<SetStateAction<INavFolder>> | null>(null);
UpdateCurrentFolderContext.displayName = 'UpdateCurrentFolderContext';

export const ActiveDocNodeContext = createContext<string | null>(null);
ActiveDocNodeContext.displayName = 'ActiveDocNodeContext';

export const UpdateActiveDocNodeContext = createContext<Dispatch<SetStateAction<string | null>> | null>(null);
UpdateActiveDocNodeContext.displayName = 'UpdateActiveDocNodeContext';
